import { PackageTypeForm } from "@/resources/packages/PackageTypeForm";

export function FrameEdit() {
  return (
    <PackageTypeForm
      action="edit"
      resource="frames"
      packageType="frame"
      label="Frame"
    />
  );
}

export default FrameEdit;
